/**
 * @desc: 服务商查询
 * @change：2020/4/13
 * @author: lijun
 * @version: v1.0
 */

import {
  getListData,
  saveService,
  serverModify,
  getServiceCity,
  getActCompany,
  getActCity,
  getServiceId,
  getDetails,
  serverState
} from '@/api/T1/serverCheck'

export default {
  namespaced: true,
  state: {
    serviceList: '',
    ServiceCondition: ''
  },
  mutations: {
    setServiceList: (state, payload) => {
      state.serviceList = payload
    },
    setServiceCondition: (state, payload) => {
      state.ServiceCondition = payload
    },
    setServiceSave: (state, payload) => {
      state.setServiceSave = payload
    },
    setActCompany: (state, payload) => {
      state.setActCompany = payload
    },
    setActCity: (state, payload) => {
      state.setActCity = payload
    },
    setModify: (state, payload) => {
      state.setModify = payload
    },
    setServiceCity: (state, payload) => {
      state.setServiceCity = payload
    },
    setServiceId: (state, payload) => {
      state.setServiceId = payload
    },
    setDetails: (state, payload) => {
      state.setDetails = payload
    }
  },
  actions: {
    //  服务商查询--列表接口
    async getListData({ commit }, payload) {
      const res = await getListData(payload)
      if (res && res.status === 200) {
        commit('setServiceList', res.data)
        return res
      }
    },
    // 服务商查询--新建渠道
    async saveService({ commit }, payload) {
      const res = await saveService(payload)
      if (res) {
        if (res.status === 200) {
          commit('setServiceSave', res.data)
          return res
        }
        if (res.status === 400) {
          return res
        }
      }
    },

    // 服务商查询 —— 服务商号接口
    async getServiceId({ commit }, payload) {
      const res = await getServiceId(payload)
      if (res && res.status === 200) {
        commit('setServiceId', res.data)
        return res
      }
    },

    // 服务商查询 —— 下拉服务城市接口
    async getServiceCity({ commit }, payload) {
      const res = await getServiceCity(payload)
      if (res && res.status === 200) {
        commit('setServiceCity', res.data)
        return res
      }
    },

    // 根据收单机构id查询该下已激活的服务城市
    async getActCity({ commit }, payload) {
      const res = await getActCity(payload)
      if (res && res.status === 200) {
        commit('setActCity', res.data)
        return res
      }
    },

    // 服务商查询 —— 获取已激活的收单机构
    async getActCompany({ commit }, payload) {
      const res = await getActCompany(payload)
      if (res && res.status === 200) {
        commit('setActCompany', res.data)
        return res
      }
    },


    // 服务商查询 - 查看
    async getDetails({ commit }, payload) {
      const res = await getDetails(payload)
      if (res && res.status === 200) {
        commit('setDetails', res.data)
        return res
      }
    },

    async serverState(ctx, payload) {
      const res = await serverState(payload)
      if (res && res.status === 200) {
        return res
      }
    },

    // 服务商查询——修改
    async storeModify(ctx, payload) {
      return await serverModify(payload)
    }
  }
}
